import Container from 'Components/Atoms/Container/Container';
import Loader from '../Loader';

const PageLoader = ({
    description
}: any) => {
    return <Container padding='vertical'>
        <Loader description={description} />
    </Container>
}

export default PageLoader;